{
  "awaleScreen": {
    "header": {
      "title": "🎯 Awale",
      "loading": "Loading Awale…"
    },
    "tabs": {
      "mine": "My Sessions",
      "explore": "Explore",
      "classement": "Leaderboard"
    },
    "mySessions": {
      "title": "My Sessions",
      "emptyTitle": "You haven't joined any session yet.",
      "emptyHint": "Explore the available sessions!",
      "enter": "Enter →",
      "runLabel": "Run {{number}} — {{title}}",
      "turnTime": "{{seconds}}s/turn"
    },
    "explore": {
      "title": "Available Sessions",
      "emptyTitle": "No session available.",
      "emptyHint": "You may have already joined all sessions.",
      "participateFree": "Join for free",
      "participatePaid": "Join ({{price}} CFA)"
    },
    "session": {
      "backToSessions": "Back to sessions",
      "noRunAvailable": "No run available for this session."
    },
    "run": {
      "matchFinishedTitle": "Match Finished",
      "matchFinishedSub": "This run is officially closed.\nCheck the leaderboard to see the winners.",
      "waitingForLaunch": "Waiting for the administrator to launch",
      "runInProgress": "Run in progress",
      "notInRun": "You're not part of this run",
      "playNow": "Play now",
      "info": {
        "run": "Run",
        "prep": "Prep.",
        "turn": "Turn",
        "launched": "Launched"
      }
    },
    "match": {
      "yourMatch": "Your match",
      "you": "You",
      "opponent": "Opponent",
      "victory": "🏆 Victory!",
      "defeat": "❌ Defeat",
      "resultPending": "Result pending"
    },
    "status": {
      "created": "⏳ Waiting",
      "launched": "🔵 In progress",
      "finished": "🟢 Finished"
    },
    "classement": {
      "title": "Leaderboard",
      "emptyTitle": "You're not enrolled in any session.",
      "backToClassement": "Back",
      "runsCount_one": "{{count}} run",
      "runsCount_other": "{{count}} runs",
      "matchesCount": "{{finished}}/{{total}} matches",
      "noRunAvailable": "No run available.",
      "noMatchInRun": "No match in this run",
      "matchLabel": "Match {{number}}",
      "matchDone": "✅ Finished",
      "matchLive": "🔵 In progress",
      "winnerLabel": "Winner · {{name}}"
    },
    "errors": {
      "joinSession": "Join session error",
      "loadRun": "Error loading run",
      "sessionExpired": "Session expired — please log in again"
    }
  },
  "damesScreen": {
    "header": {
      "title": "♟️ Checkers",
      "loading": "Loading Checkers…"
    },
    "tabs": {
      "mine": "My Sessions",
      "explore": "Explore",
      "classement": "Leaderboard"
    },
    "mySessions": {
      "title": "My Sessions",
      "emptyTitle": "You haven't joined any session yet.",
      "emptyHint": "Explore the available sessions!",
      "enter": "Enter →",
      "runLabel": "Run {{number}} — {{title}}",
      "turnTime": "{{seconds}}s/turn"
    },
    "explore": {
      "title": "Available Sessions",
      "emptyTitle": "No session available.",
      "emptyHint": "You may have already joined all sessions.",
      "participateFree": "Join for free",
      "participatePaid": "Join ({{price}} CFA)"
    },
    "session": {
      "backToSessions": "Back to sessions",
      "noRunAvailable": "No run available for this session."
    },
    "run": {
      "matchFinishedTitle": "Match Finished",
      "matchFinishedSub": "This run is officially closed.\nCheck the leaderboard to see the winners.",
      "waitingForLaunch": "Waiting for the administrator to launch",
      "runInProgress": "Run in progress",
      "notInRun": "You're not part of this run",
      "playNow": "Play now",
      "info": {
        "run": "Run",
        "prep": "Prep.",
        "turn": "Turn",
        "launched": "Launched"
      }
    },
    "match": {
      "yourMatch": "Your match",
      "you": "You",
      "opponent": "Opponent",
      "victory": "🏆 Victory!",
      "defeat": "❌ Defeat",
      "resultPending": "Result pending"
    },
    "status": {
      "created": "⏳ Waiting",
      "launched": "🔵 In progress",
      "finished": "🟢 Finished"
    },
    "classement": {
      "title": "Leaderboard",
      "emptyTitle": "You're not enrolled in any session.",
      "backToClassement": "Back",
      "runsCount_one": "{{count}} run",
      "runsCount_other": "{{count}} runs",
      "matchesCount": "{{finished}}/{{total}} matches",
      "noRunAvailable": "No run available.",
      "noMatchInRun": "No match in this run",
      "matchLabel": "Match {{number}}",
      "matchDone": "✅ Finished",
      "matchLive": "🔵 In progress",
      "winnerLabel": "Winner · {{name}}"
    },
    "errors": {
      "joinSession": "Join session error",
      "loadRun": "Error loading run",
      "sessionExpired": "Session expired — please log in again"
    }
  },
  "tabAwale": {
    "connecting": "Connecting to server…",
    "loadingMatch": "Loading match…",
    "back": "Back",
    "connectionError": "Unable to connect to the server",
    "prep": {
      "title": "Preparation",
      "subtitle": "The match starts in",
      "unit": "seconds",
      "hint": "Your opponent can join at any time"
    },
    "tiebreaker": {
      "banner": "🔥 Tie — First to 12 wins!",
      "small": "🔥 Tiebreaker round — First to 12",
      "badge": "🔥 Tiebreaker round"
    },
    "gameOver": {
      "victory": "Victory!",
      "defeat": "Defeat",
      "reasonTimeout": "Time's up",
      "reasonScore": "Score reached",
      "reasonEmpty": "Board empty",
      "you": "You",
      "opponent": "Opponent",
      "done": "Done"
    },
    "yourTurn": "🟢 Your turn",
    "opponentTurn": "⏳ Opponent's turn",
    "moveNumber": "Move #{{number}}",
    "reconnecting": "⚠ Reconnecting…"
  },
  "tabDames": {
    "connecting": "Connecting to server…",
    "loadingMatch": "Loading match…",
    "back": "Back",
    "connectionError": "Unable to connect to the server",
    "prep": {
      "title": "Preparation",
      "subtitle": "The match starts in",
      "unit": "seconds",
      "hint": "Red plays first"
    },
    "suddenDeath": {
      "banner": "⚡ Sudden Death — First to {{target}} captures wins!",
      "small": "⚡ Sudden Death — {{current}}/{{target}} captures",
      "badge": "⚡ Sudden Death"
    },
    "gameOver": {
      "victory": "Victory!",
      "defeat": "Defeat",
      "reasonTimeout": "Time's up",
      "reasonNoPieces": "No pieces left",
      "reasonNoMoves": "No possible move",
      "reasonSuddenDeath": "{{target}} captures reached",
      "youPlay": "You're playing {{color}}",
      "colorRed": "Red",
      "colorBlack": "Black",
      "captures": "Captures",
      "done": "Done",
      "opponent": "Opponent"
    },
    "yourTurn": "🟢 Your turn",
    "opponentTurn": "⏳ Opponent's turn",
    "chainCapture": "🔗 Chain capture!",
    "youAre": "You are {{color}} ↓",
    "moveCount": "Move #{{number}}",
    "reconnecting": "⚠ Reconnecting…",
    "movesAvailable_one": "{{count}} possible move",
    "movesAvailable_other": "{{count}} possible moves",
    "noMoveAvailable": "No possible move",
    "capturesShort": "cap."
  },
  "performanceScreen": {
    "header": {
      "title": "🎭 Performance",
      "subtitle": "Performance contest"
    },
    "tabs": {
      "sessions": "Sessions",
      "explore": "Explore",
      "submit": "Submit",
      "classement": "Leaderboard"
    },
    "empty": {
      "noSessionJoined": "No session joined",
      "exploreHint": "Explore the available contests",
      "noActiveRun": "No active run for this session",
      "noContestAvailable": "No contest available",
      "comeBackLater": "Check back later",
      "noSubmissionOpenRun": "No run open for submissions",
      "waitAdminHint": "Wait for the administrator to open submissions",
      "noResultAvailable": "No result available",
      "resultsAppearHint": "The leaderboard appears once voting is open"
    },
    "noActiveRunBadge": "No active run",
    "back": "Back",
    "notEnrolled": "You're not yet enrolled in this run",
    "submitVideosButton_one": "Submit {{count}} video",
    "submitVideosButton_other": "Submit {{count}} videos",
    "completeSubmissions": "Complete my submissions ({{current}}/{{max}})",
    "mySubmissions": "My submissions ({{current}}/{{max}})",
    "participateFree": "Join — Free",
    "participatePaid": "Join — {{price}} CFA",
    "videosToSubmit_one": "{{count}} video to submit",
    "videosToSubmit_other": "{{count}} videos to submit",
    "videosRequired_one": "{{count}} video required",
    "videosRequired_other": "{{count}} videos required",
    "chooseRun": "Choose a run",
    "chooseAnotherRun": "Choose another run",
    "videosProgress_one": "{{count}} video",
    "videosProgress_other": "{{count}} videos",
    "readyToSend": "✓ Ready to send",
    "missingVideos_one": "{{count}} missing",
    "missingVideos_other": "{{count}} missing",
    "ruleExact": "This run requires exactly",
    "ruleAllSlots": "All slots must be filled before sending.",
    "sendVideos_one": "Send {{count}} video",
    "sendVideos_other": "Send {{count}} videos",
    "fillAllSlots": "Fill all slots ({{ready}}/{{total}})",
    "successTitle": "✅ Submission complete",
    "successMessage_one": "Your video was submitted successfully!",
    "successMessage_other": "Your {{count}} videos were submitted successfully!",
    "status": {
      "draft": "📝 Draft",
      "submissionsOpen": "🎥 Submissions open",
      "votingOpen": "🗳️ Voting open",
      "finished": "🏆 Finished"
    },
    "slot": {
      "videoLabel": "Video {{number}}",
      "alreadySubmitted": "Already submitted",
      "required": "Required",
      "tapToChoose": "Tap to choose",
      "tapToChange": "Tap to change",
      "formats": "MP4 · MOV · WEBM",
      "descriptionPlaceholder": "Description (optional)…"
    },
    "uploadSteps": {
      "preparing": "Video {{current}}/{{total}} — Preparing…",
      "sending": "Video {{current}}/{{total}} — Sending…",
      "saving": "Video {{current}}/{{total}} — Saving…",
      "uploadFailed": "Video {{number}} upload failed ({{status}})"
    },
    "permission": {
      "title": "Permission required",
      "message": "Allow access to your gallery."
    }
  },
  "musicScreen": {
    "header": {
      "title": "🎵 Music",
      "subtitle": "Music contest"
    },
    "tabs": {
      "sessions": "Sessions",
      "explore": "Explore",
      "submit": "Submit",
      "classement": "Leaderboard"
    },
    "empty": {
      "noSessionJoined": "No session joined",
      "exploreHint": "Explore the available contests",
      "noActiveRun": "No active run for this session",
      "noContestAvailable": "No contest available",
      "comeBackLater": "Check back later",
      "noSubmissionOpenRun": "No run open for submissions",
      "waitAdminHint": "Wait for the administrator to open submissions",
      "noResultAvailable": "No result available",
      "resultsAppearHint": "The leaderboard appears once voting is open"
    },
    "noActiveRunBadge": "No active run",
    "back": "Back",
    "notEnrolled": "You're not yet enrolled in this run",
    "submitVideosButton_one": "Submit {{count}} video",
    "submitVideosButton_other": "Submit {{count}} videos",
    "completeSubmissions": "Complete my submissions ({{current}}/{{max}})",
    "mySubmissions": "My submissions ({{current}}/{{max}})",
    "participateFree": "Join — Free",
    "participatePaid": "Join — {{price}} CFA",
    "videosToSubmit_one": "{{count}} video to submit",
    "videosToSubmit_other": "{{count}} videos to submit",
    "videosRequired_one": "{{count}} video required",
    "videosRequired_other": "{{count}} videos required",
    "chooseRun": "Choose a run",
    "chooseAnotherRun": "Choose another run",
    "videosProgress_one": "{{count}} video",
    "videosProgress_other": "{{count}} videos",
    "readyToSend": "✓ Ready to send",
    "missingVideos_one": "{{count}} missing",
    "missingVideos_other": "{{count}} missing",
    "ruleExact": "This run requires exactly",
    "ruleAllSlots": "All slots must be filled before sending.",
    "sendVideos_one": "Send {{count}} video",
    "sendVideos_other": "Send {{count}} videos",
    "fillAllSlots": "Fill all slots ({{ready}}/{{total}})",
    "successTitle": "✅ Submission complete",
    "successMessage_one": "Your video was submitted successfully!",
    "successMessage_other": "Your {{count}} videos were submitted successfully!",
    "status": {
      "draft": "📝 Draft",
      "submissionsOpen": "🎥 Submissions open",
      "votingOpen": "🗳️ Voting open",
      "finished": "🏆 Finished"
    },
    "slot": {
      "videoLabel": "Video {{number}}",
      "alreadySubmitted": "Already submitted",
      "required": "Required",
      "tapToChoose": "Tap to choose",
      "tapToChange": "Tap to change",
      "formats": "MP3 · WAV · M4A",
      "descriptionPlaceholder": "Description (optional)…"
    },
    "uploadSteps": {
      "preparing": "Audio {{current}}/{{total}} — Preparing…",
      "sending": "Audio {{current}}/{{total}} — Sending…",
      "saving": "Audio {{current}}/{{total}} — Saving…",
      "uploadFailed": "Audio {{number}} upload failed ({{status}})"
    }
  },
  "artisanatScreen": {
    "header": {
      "title": "🪡 Crafts",
      "subtitle": "Crafts contest"
    },
    "tabs": {
      "sessions": "Sessions",
      "explore": "Explore",
      "submit": "Submit",
      "classement": "Leaderboard"
    },
    "empty": {
      "noSessionJoined": "No session joined",
      "exploreHint": "Explore the available contests",
      "noActiveRun": "No active run for this session",
      "noContestAvailable": "No contest available",
      "comeBackLater": "Check back later",
      "noSubmissionOpenRun": "No run open for submissions",
      "waitAdminHint": "Wait for the administrator to open submissions",
      "noResultAvailable": "No result available",
      "resultsAppearHint": "The leaderboard appears once voting is open"
    },
    "noActiveRunBadge": "No active run",
    "back": "Back",
    "notEnrolled": "You're not yet enrolled in this run",
    "submitVideosButton_one": "Submit {{count}} video",
    "submitVideosButton_other": "Submit {{count}} videos",
    "completeSubmissions": "Complete my submissions ({{current}}/{{max}})",
    "mySubmissions": "My submissions ({{current}}/{{max}})",
    "participateFree": "Join — Free",
    "participatePaid": "Join — {{price}} CFA",
    "videosToSubmit_one": "{{count}} video to submit",
    "videosToSubmit_other": "{{count}} videos to submit",
    "videosRequired_one": "{{count}} video required",
    "videosRequired_other": "{{count}} videos required",
    "chooseRun": "Choose a run",
    "chooseAnotherRun": "Choose another run",
    "videosProgress_one": "{{count}} video",
    "videosProgress_other": "{{count}} videos",
    "readyToSend": "✓ Ready to send",
    "missingVideos_one": "{{count}} missing",
    "missingVideos_other": "{{count}} missing",
    "ruleExact": "This run requires exactly",
    "ruleAllSlots": "All slots must be filled before sending.",
    "sendVideos_one": "Send {{count}} video",
    "sendVideos_other": "Send {{count}} videos",
    "fillAllSlots": "Fill all slots ({{ready}}/{{total}})",
    "successTitle": "✅ Submission complete",
    "successMessage_one": "Your video was submitted successfully!",
    "successMessage_other": "Your {{count}} videos were submitted successfully!",
    "status": {
      "draft": "📝 Draft",
      "submissionsOpen": "🎥 Submissions open",
      "votingOpen": "🗳️ Voting open",
      "finished": "🏆 Finished"
    },
    "slot": {
      "videoLabel": "Video {{number}}",
      "alreadySubmitted": "Already submitted",
      "required": "Required",
      "tapToChoose": "Tap to choose",
      "tapToChange": "Tap to change",
      "formats": "MP4 · MOV · WEBM",
      "descriptionPlaceholder": "Description (optional)…"
    },
    "uploadSteps": {
      "preparing": "Video {{current}}/{{total}} — Preparing…",
      "sending": "Video {{current}}/{{total}} — Sending…",
      "saving": "Video {{current}}/{{total}} — Saving…",
      "uploadFailed": "Video {{number}} upload failed ({{status}})"
    },
    "permission": {
      "title": "Permission required",
      "message": "Allow access to your gallery."
    }
  },
  "artsScreen": {
    "header": {
      "title": "🎨 Arts",
      "subtitle": "Creative contests"
    },
    "tabs": {
      "sessions": "Sessions",
      "explore": "Explore",
      "submit": "Submit",
      "classement": "Leaderboard"
    },
    "empty": {
      "noSessionJoined": "No session joined",
      "exploreHint": "Explore the available contests",
      "noActiveRun": "No active run for this session",
      "noContestAvailable": "No contest available",
      "comeBackLater": "Check back later",
      "noSubmissionOpenRun": "No run open for submissions",
      "waitAdminHint": "Wait for the administrator to open submissions",
      "noResultAvailable": "No result available",
      "resultsAppearHint": "The leaderboard appears once voting is open"
    },
    "noActiveRunBadge": "No active run",
    "back": "Back",
    "notEnrolled": "You're not yet enrolled in this run",
    "submitWorksButton_one": "Submit {{count}} work",
    "submitWorksButton_other": "Submit {{count}} works",
    "completeSubmissions": "Complete my submissions ({{current}}/{{max}})",
    "mySubmissions": "My submissions ({{current}}/{{max}})",
    "participateFree": "Join — Free",
    "participatePaid": "Join — {{price}} CFA",
    "worksToSubmit_one": "{{count}} work to submit",
    "worksToSubmit_other": "{{count}} works to submit",
    "worksRequired_one": "{{count}} work required",
    "worksRequired_other": "{{count}} works required",
    "chooseRun": "Choose a run",
    "chooseAnotherRun": "Choose another run",
    "worksProgress_one": "{{count}} work",
    "worksProgress_other": "{{count}} works",
    "readyToSend": "✓ Ready to send",
    "missingWorks_one": "{{count}} missing",
    "missingWorks_other": "{{count}} missing",
    "ruleExact": "This run requires exactly",
    "ruleAllSlots": "All slots must be filled before sending.",
    "sendWorks_one": "Send {{count}} work",
    "sendWorks_other": "Send {{count}} works",
    "fillAllSlots": "Fill all slots ({{ready}}/{{total}})",
    "successTitle": "✅ Submission complete",
    "successMessage_one": "Your work was submitted successfully!",
    "successMessage_other": "Your {{count}} works were submitted successfully!",
    "status": {
      "draft": "📝 Draft",
      "submissionsOpen": "🖼️ Submissions open",
      "votingOpen": "🗳️ Voting open",
      "finished": "🏆 Finished"
    },
    "quota": "{{current}}/{{max}} submission",
    "quota_other": "{{current}}/{{max}} submissions",
    "slot": {
      "workLabel": "Work {{number}}",
      "alreadySubmitted": "Already submitted",
      "required": "Required",
      "tapToChoose": "Tap to choose",
      "tapToChange": "Tap to change",
      "formats": "JPG · PNG · WEBP",
      "descriptionPlaceholder": "Description (optional)…"
    },
    "uploadSteps": {
      "preparing": "Image {{current}}/{{total}} — Preparing…",
      "sending": "Image {{current}}/{{total}} — Sending…",
      "saving": "Image {{current}}/{{total}} — Saving…",
      "uploadFailed": "Image {{number}} upload failed ({{status}})"
    },
    "permission": {
      "title": "Permission required",
      "message": "Allow access to your gallery."
    }
  },
  "vraiFauxScreen": {
    "title": "True or False",
    "loading": "Loading…",
    "tabs": {
      "sessions": "Sessions",
      "explore": "Explore",
      "answers": "Answers",
      "results": "Results"
    },
    "headerSub": {
      "groups": "GROUPS",
      "questions": "QUESTIONS",
      "mySessions": "MY SESSIONS",
      "explore": "EXPLORE",
      "myAnswers": "MY ANSWERS",
      "myResults": "MY RESULTS"
    },
    "mine": {
      "emptyTitle": "No session joined",
      "emptySub": "Explore the available sessions and join in!",
      "exploreAction": "Explore",
      "groupsLabel": "GROUPS",
      "openGroup": "Group open to everyone",
      "minScore": "Min. score: {{score}} pts",
      "locked": "🔒 Required: {{required}} pts · You: {{current}} pts",
      "answerButton": "Answer",
      "insufficientScore": "Insufficient score — you have {{current}} pts, {{required}} pts required",
      "allAnswered": "All questions answered!",
      "backToGroups": "Back to groups",
      "questionCounter": "Question {{current}} / {{total}}",
      "previous": "Previous",
      "next": "Next"
    },
    "explore": {
      "allJoinedTitle": "All joined!",
      "allJoinedSub": "You're taking part in every available session.",
      "free": "Free",
      "paid": "💰 {{price}} CFA",
      "participate": "Join"
    },
    "answers": {
      "participatedSessions": "SESSIONS JOINED",
      "emptyTitle": "No answers",
      "emptySub": "Join a session to see your answers.",
      "groupsLabel": "GROUPS — {{session}}",
      "myAnswersLabel": "MY ANSWERS",
      "infoBanner": "Scores and correct answers will be revealed by the administrator in the Results tab",
      "emptyRunTitle": "No answers",
      "emptyRunSub": "You haven't answered any questions in this group yet.",
      "myAnswerWas": "I answered: {{answer}}"
    },
    "results": {
      "participatedSessions": "SESSIONS JOINED",
      "emptyTitle": "No results",
      "emptySub": "Join a session to see your results.",
      "groupsLabel": "GROUPS — {{session}}",
      "pendingTitle": "Results not yet revealed",
      "pendingDefaultMsg": "The administrator will reveal the results after the run closes.",
      "scoreRevealed": "Revealed score:",
      "notPlayed": "Not played",
      "pointsAwarded": "+{{points}} pts"
    },
    "true": "TRUE",
    "false": "FALSE",
    "points": "{{count}} pts",
    "errors": {
      "network": "Network error",
      "notConnected": "Not connected",
      "sessionExpired": "Session expired — please log in again",
      "submitError": "Submission error"
    }
  }
  }
